import * as index from '@syncfusion/ej2-calendars';
index.Calendar.Inject( index.Islamic);
index.DatePicker.Inject( index.Islamic);
index.DateTimePicker.Inject( index.Islamic);
export * from '@syncfusion/ej2-calendars';
